// =========================================
// db.js — router del data layer
// =========================================
//
// Seleziona l'implementazione dello store in base alla config Firebase:
//   • Firebase configurato (client + chiavi/emulatori) → db.firestore.js
//   • altrimenti (default, SSR, dev senza chiavi)       → db.local.js
//
// Entrambe espongono la stessa API sincrona, quindi il resto dell'app non
// cambia. La scelta è fatta una volta all'import: lato client con Firebase
// attivo si usa Firestore; durante l'SSR o senza config si usa il backend
// locale (SSR-safe).

import { firebaseEnabled } from '../firebase/config';
import * as local from './db.local';
import * as firestore from './db.firestore';

const impl = firebaseEnabled() ? firestore : local;

export const subscribe         = impl.subscribe;
export const ensureTenant      = impl.ensureTenant;
export const getCollection     = impl.getCollection;
export const getDocById        = impl.getDocById;
export const setDoc            = impl.setDoc;
export const updateDoc         = impl.updateDoc;
export const deleteDoc         = impl.deleteDoc;
export const resetTenant       = impl.resetTenant;
export const getReadings       = impl.getReadings;

// Presente solo sul backend Firestore; no-op altrove. Usato dal logout per
// staccare i listener onSnapshot del tenant (evita errori permission-denied).
export const detachTenant      = impl.detachTenant || (() => {});
